import React, {useEffect, useRef} from 'react'
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import SqftStepSelectSlab from "./SqftStepSelectSlab";
import {
  setSqftCroppedSlabImages,
  setActiveStep,
  setActiveSlabUrl,
} from "../../../../actions/sqftSlabFunctions";
import SqftStepCropSlab from "./SqftStepCropSlab";
import SqftStepSelectImageType from "./SqftStepSelectImageType";
import SqftLoadSlabHeader from "./SqftLoadSlabHeader";
import SqftLoadSlabFooter from "./SqftLoadSlabFooter";

const SqftLoadSlabWindow = (props) => {
  const {activeButton} = props;
  const {activeStep, setActiveStep} = props;
  const cropperRef = useRef(null);
  const expanded = activeButton === "loadSlab";

  useEffect(() => {
    expanded ? setActiveStep(0) : null
  }, [expanded, setActiveStep]);

  return (
    <div className={"message-box-overlay message-box-overlay--slab " + (expanded ? "" : "hidden")}>
      <div className="message-window-base slab">
        <SqftLoadSlabHeader cropperRef={cropperRef}/>
        <div className="message-window-container container-fluid">
          {activeStep === 0 ? <SqftStepSelectImageType/> : "" }
          {activeStep === 1 ? <SqftStepSelectSlab/> : "" }
          {activeStep === 2 ? <SqftStepCropSlab cropperRef={cropperRef}/> : "" }
        </div>
        <SqftLoadSlabFooter cropperRef={cropperRef}/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  activeStep: store.sqftSlabState.activeStep,
  activeButton: store.sqftMenuState.activeButton,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setActiveStep,
  setActiveSlabUrl,
  setSqftCroppedSlabImages,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabWindow)
)

